import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatErr } from "@/lib/api";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await register(f); toast.success("Account created"); nav("/dashboard"); }
    catch (err) { toast.error(formatErr(err)); } finally { setLoading(false); }
  };
  return (
    <div data-testid="register-page" className="min-h-[80vh] flex items-center px-6 py-16">
      <div className="max-w-md w-full mx-auto sk-card-dark p-10">
        <img src="/assets/sk-logo.jpeg" alt="SK Group" className="w-16 h-16 rounded-full ring-1 ring-[#D4AF37]/40 mx-auto"/>
        <h1 className="font-display text-3xl text-white mt-6 text-center">Create your account</h1>
        <p className="text-white/50 text-sm text-center mt-1">Track loans · Upload documents · Manage EMIs</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          {[
            { k:"name", l:"Full name", type:"text" },
            { k:"email", l:"Email", type:"email" },
            { k:"phone", l:"Phone", type:"tel" },
            { k:"password", l:"Password (min 6 chars)", type:"password" },
          ].map(field => (
            <label key={field.k} className="block">
              <div className="text-xs uppercase tracking-widest text-white/50 mb-2">{field.l}</div>
              <input data-testid={`register-${field.k}`} required type={field.type} className="sk-input" value={f[field.k]} onChange={(e)=>setF({...f,[field.k]:e.target.value})}/>
            </label>
          ))}
          <button data-testid="register-submit" disabled={loading} className="sk-btn-gold w-full">{loading?"Creating...":"Create account"}</button>
        </form>
        <div className="mt-6 text-center text-sm text-white/60">
          Already have an account? <Link to="/login" className="text-[#D4AF37] hover:underline">Login</Link>
        </div>
      </div>
    </div>
  );
}
